import styled from "styled-components"

interface IChooseGenderProps {
    female: boolean,
    onClick: (female: boolean) => void
}

export const ChooseGender = (props: IChooseGenderProps) => {

    return (
        <Root>
            <GenderButton active={props.female} onClick={() => props.onClick(true)}>Pige</GenderButton>
            <div>&nbsp;</div>
            <GenderButton active={!props.female} onClick={() => props.onClick(false)}>Dreng</GenderButton>
        </Root>
    )
}

const Root = styled.div`
    display: flex;
    justify-content: space-evenly;
    margin-bottom: 8px;
`;

const GenderButton = styled.div<{ active: boolean }>`
    display: inline;
    font-size: 22px;
    font-weight: 700;
    border: 4px solid ${props => props.active ? "#FCAF00" : "#326577" };
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;
    height: 60px;
    padding: 8px;
    margin-bottom: 8px;
    color: #183F48;
    background-color: #EBEBEB;
`;